export default __webpack_public_path__ + "static/media/back.0f67e245.svg";